/**
 * Runtime configuration for all tenants (ooru, stp, …).
 *
 * Priority:
 *   1. window.__RUNTIME_CONFIG__ from /config.js
 *      - Docker/K8s: written by entrypoint from container env (Vault/K8s secrets)
 *      - CDN: uploaded per environment next to the static build
 *   2. process.env (local `npm start` / optional legacy baked builds)
 */
export function getRuntimeEnv(key, fallback) {
  if (typeof window !== "undefined") {
    const runtime = window.__RUNTIME_CONFIG__;
    if (
      runtime &&
      Object.prototype.hasOwnProperty.call(runtime, key) &&
      runtime[key] !== undefined &&
      runtime[key] !== null &&
      runtime[key] !== ""
    ) {
      return String(runtime[key]);
    }
  }

  const fromProcess =
    typeof process !== "undefined" && process.env
      ? process.env[key]
      : undefined;
  if (fromProcess !== undefined && fromProcess !== null && fromProcess !== "") {
    return String(fromProcess);
  }

  return fallback;
}

export default getRuntimeEnv;
